import { DATA_TYPE_TO_CATEGORY } from "@single-js/common/util/data-type";
import { _formatPartitionStatus } from "view/common/models/cluster-metadata";
const COLUMN_CATEGORY_ICON = {
    number: "hashtag",
    datetime: "calendar-alt",
    string: "font",
    json: "json",
    geospatial: "globe",
    enum: "ballot-check",
};
export function formatDatabaseStatus(database) {
    return _formatPartitionStatus(database.derived.status, database.derived.impacted);
}
export function getDatabaseStatusLevel(database) {
    if (database.status === "online" && !database.impacted) {
        return "success";
    }
    else if (database.status === "offline_recovering" ||
        database.status === "offline") {
        return "error";
    }
    else {
        return "warning";
    }
}
export function getColumnIcon(column) {
    return (COLUMN_CATEGORY_ICON[DATA_TYPE_TO_CATEGORY[column.dataType]] ||
        "question");
}
